module.exports = __webpack_public_path__ + "img/self-diagnosis-intro.ad725a69.jpg";